import { createStore, createEvent } from "effector"
import { Guid } from "@/types"
import assetSidebars from "stores/assetSidebars"
import globalAssetOverviewAssetSidebars from "stores/globalAssetOverviewAssetSidebars"

// Event to set the highlighted LMID when clicked
const setHighlightedAssetId = createEvent<Guid>()

// Event to clear the highlight
const clearHighlight = createEvent()

// Store for the assetId that should be highlighted
const $highlightedAssetId = createStore<Guid | null>(null)
    .on(setHighlightedAssetId, (_, assetId) => assetId)
    .on(clearHighlight, () => null)

// Clear on page navigation
assetSidebars.clear.watch(() => {
    clearHighlight()
})

globalAssetOverviewAssetSidebars.clear.watch(() => {
    clearHighlight()
})

export default {
    setHighlightedAssetId,
    $highlightedAssetId,
}